import * as FullStory from '@fullstory/browser'

const sendFullStoryEvent = (eventName: string, eventData: object) => {
    if (!FullStory.isInitialized()) {
        console.log('Unable to send event FullStory event')
        return
    }

    FullStory.event(eventName, eventData)
}

export default sendFullStoryEvent
